import { Tooltip } from 'antd';
import { useRef, useState } from 'react';

interface EllipsisTooltipProps {
  text: string;
  className?: string;
  style?: React.CSSProperties;
  zIndex?: number;
  /** Class on the tooltip popup, for callers that need to restyle it. */
  tooltipClassName?: string;
}

/**
 * Renders text with CSS ellipsis and shows a tooltip with the full text
 * only when the content is actually overflowing (scrollWidth > clientWidth).
 */
export default function EllipsisTooltip({
  text,
  className,
  style,
  zIndex,
  tooltipClassName,
}: EllipsisTooltipProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [title, setTitle] = useState<string | undefined>(undefined);

  const handleMouseEnter = () => {
    const el = ref.current;
    setTitle(el && el.scrollWidth > el.clientWidth ? text : undefined);
  };

  return (
    <Tooltip
      title={title}
      mouseEnterDelay={0.3}
      destroyOnHidden
      zIndex={zIndex}
      classNames={tooltipClassName ? { root: tooltipClassName } : undefined}
    >
      <span
        ref={ref}
        className={className}
        // `style` is part of this component's own API, passed through from callers
        // eslint-disable-next-line react/forbid-dom-props
        style={style}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setTitle(undefined)}
      >
        {text}
      </span>
    </Tooltip>
  );
}
